import { ColorValue, StyleProp, View, ViewStyle } from 'react-native'

export const DEFAULT_BOX_HEIGHT = 26

export function Box({
  color,
  height = DEFAULT_BOX_HEIGHT,
  width = height / 2,
  style,
}: {
  height?: number
  width?: number
  color: ColorValue
  style?: StyleProp<ViewStyle>
}) {
  return (
    <View
      style={[style, { backgroundColor: color, height: height, width: width }]}
    />
  )
}
